export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_NEWREGISTERS':
      return { newRegisters: action.newRegisters };
    default:
      return state;
  }
};
